import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light bg-white" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kometa-navigace",
  "aria-controls": "kometa-navigace",
  "aria-expanded": "false",
  "aria-label": "Zobraz nabádku"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "kometa-navigace",
  ref: "navigation"
}
const _hoisted_5 = { class: "navbar-nav ms-auto" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" O nás ")
const _hoisted_8 = { class: "nav-item dropdown" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link dropdown-toggle",
  id: "tymyDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Týmy ", -1)
const _hoisted_10 = {
  class: "dropdown-menu",
  "aria-labelledby": "tymyDropdown"
}
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Trénérský tým ")
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Kontakt ")
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = {
  href: "https://www.youtube.com/channel/UCdXgAprvLzHHiCwObnwz7pg",
  title: "YouTube",
  class: "nav-link kometa-nav-youtube"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" YouTube ")
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Přidej se k nám ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon = _resolveComponent("icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'home' },
        onClick: _ctx.hideNavigation,
        class: "navbar-brand"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_logo)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: { name: 'aboutUs' },
              onClick: _ctx.hideNavigation,
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: team.id
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'teams', params: { teamId: team.id } },
                    class: "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(team.jmeno), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: { name: 'coachTeam' },
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: { name: 'contact' },
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, [
              _createVNode(_component_icon, {
                type: "fab",
                "icon-name": "youtube"
              }),
              _hoisted_17
            ])
          ]),
          _createElementVNode("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: { name: 'joinUs' },
              class: "nav-link btn-sm kometa-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ])
      ], 512)
    ])
  ])), [
    [_directive_click_outside, _ctx.hideNavigation]
  ])
}